<!-- static content data from lang: question -->
<template>
  <div>
    <div class="h-100" v-loading="loading">
      <base-header class="pb-6">
        <div class="row align-items-center pb-4">
          <div class="col-lg-12 col-12">
            <h6 class="h2 text-white d-inline-block mb-0">{{lang.label.headerTitle}}</h6>
            <nav aria-label="breadcrumb" class="d-inline-block ml-4">
              <route-bread-crumb></route-bread-crumb>
            </nav>
          </div>
        </div>
      </base-header>
      <div class="container-fluid mt--6">
        <div>
          <card class="no-border-card mb-0" body-classes="px-0 pb-1" footer-classes="pb-2">
             <div class="col-12">
               <template v-for="(message) in alertMessages">
                 <Alert :type = alertType dismissible  v-if="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
               </template>
               <template v-for="(message) in successMessages">
                 <Alert :type = successType dismissible  v-if="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
               </template>
             </div>
            <div>
              <div class="col-12 text-right mb-3">
                <base-button type="primary" @click="addClick()">{{lang.label.buttons.add}}</base-button>
              </div>
              <div class="col-12 text-center text-lg-left">
                <div class="row">
                  <div
                    class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                  >
                    <el-select
                      class="select-primary pagination-select"
                      v-model="pagination.perPage"
                      autocomplete="off"
                      placeholder="Per page"
                    >
                      <el-option
                        class="select-primary"
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>

                    <div>
                      <base-input
                        v-model="searchQuery"
                        autocomplete="off"
                        prepend-icon="fas fa-search"
                        :placeholder="lang.label.search"
                      ></base-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <el-table
                  :data="queriedData"
                  row-key="id"
                  header-row-class-name="thead-light"
                  @sort-change="sortChange"
                  @selection-change="selectionChange"
                  border
                >
<!--                  <el-table-column width="150px" label="Name" prop="Name" sortable></el-table-column>-->
                  <el-table-column min-width="250px" label="Name" sortable prop="Name">
                    <div class="d-flex" slot-scope="scope" v-html="scope.row.Name"></div>
                  </el-table-column>
                  <el-table-column width="200px" align="right" label="Actions" prop="ID">
                    <div class="d-flex" slot-scope="scope">
                      <el-tooltip :content="lang.label.tooltips.edit" placement="bottom">
                        <base-button
                          class="btn-link"
                          type="info"
                          size="sm"
                          icon
                          @click="edit(scope.row.ID)"
                        >
                          <i class="text-white fas fa-pencil-alt"></i>
                        </base-button>
                      </el-tooltip>
                      <el-tooltip :content="lang.label.tooltips.delete" placement="bottom">
                        <base-button
                          class="btn-link"
                          type="danger"
                          size="sm"
                          icon
                          @click.native="showSwal(scope.row.ID)"
                        >
                          <i class="text-white fas fa-trash-alt"></i>
                        </base-button>
                      </el-tooltip>
                    </div>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div
              class="col-12 mt-3 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class>
                <p class="card-category">
                  {{lang.label.showPagination.showing}} {{ from + 1 }} {{lang.label.showPagination.to}} {{ to }} {{lang.label.showPagination.of}} {{ total }} {{lang.label.showPagination.entries}}
                  <span
                    v-if="selectedRows.length"
                  >&nbsp; &nbsp; {{selectedRows.length}} {{lang.label.showPagination.rowsSelected}}</span>
                </p>
              </div>
              <base-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
              ></base-pagination>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import {mapGetters} from "vuex";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../../Tables/PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Alert from "@/components/BaseAlert.vue";

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    flatPicker,
    Alert,
  },
  data() {
    return {
      lang: this.$lang.group_management,
      loading: false,
      alertType: 'danger',
      successType: 'success',
      alertMessages: [],
      successMessages: [],
      propsToSearch: ["Name"],
      selectedindex: 0,
      tableColumns: [
        {
          type: "selection"
        }
      ],
      tableData: [],
      selectedRows: [],
    };
  },
  computed:{
        ...mapGetters({
            successMessage: "successMessage",
            alertMessage: "alertMessage",
            login: "login",
        })
  },
  mounted() {
      let self = this;
      if(this.successMessage) {
          this.successMessages.push(this.successMessage);
      }
      if(this.alertMessage) {
          this.alertMessages.push(this.alertMessage);
      }
      this.groupList();
  },
  methods: {
      showSwal(ID) {
          let self = this;
          swal.fire({
              title: "Are you sure?",
              text: "Do you really want to delete this record? Deleting this will also delete it's corresponding child data as well.",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Yes, delete it!",
              cancelButtonText: "No, keep it",
              buttonsStyling: false,
              customClass: {
                  confirmButton: "btn btn-primary btn-fill",
                  cancelButton: "btn btn-danger btn-fill"
              }
          })
              .then(result => {
                  if (result.value) {
                      this.loading = true;
                      this.$store
                          .dispatch("deleteVisitorGroup", ID)
                          .then(response => {
                              self.groupList(response.data.message);
                          }).catch(error => {
                          this.loading = false;

                      });
                  }
              });
      },
      groupList(message = '') {
        let self = this;
        this.loading = true;
        this.$store.dispatch('visitorGroupList', {ID: this.login.ID})
            .then(response => {
                setTimeout(function () {
                    self.successMessages = [];
                    self.alertMessages = [];
                    self.$store.commit('setAlertMessage', null)
                }, 5000)
                if(response.status == 200) {
                    this.tableData = response.data;
                    if(message) {
                        self.successMessages.push(message);
                        setTimeout(function () {
                            self.successMessages = [];
                        }, 5000);
                    }
                }else {
                    if(typeof response.data.message != 'object'){
                        this.alertMessages.push(response.data.message);
                        setTimeout(function () {
                            self.alertMessages = [];
                        }, 5000);
                    }else{
                        var array = new Array();
                        for (let key of Object.keys(response.data.message)) {
                            let obj = response.data.message[key][0].includes('field') ? (key+"- "+response.data.message[key][0]) : response.data.message[key];
                            array.push(obj)
                        }
                        this.alertMessages.push(array.join(', '));
                        setTimeout(function () {
                            self.alertMessages = [];
                        }, 5000);
                    }
                }
                this.loading = false;
            })
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    addClick() {
      this.$router.push({ name: "addGroupManagement" });
    },
    edit(ID) {
      this.$router.push({ name: "editGroupManagement", params: { id: ID } });
    },
    onSubmit() {},
  }
};
</script>

<style>
.no-border-card .card-footer {
  border-top: 0;
}
.modal-header {
  padding-bottom: 0;
}
</style>
